import { render } from "./Research.vue?vue&type=template&id=0889597f&scoped=true"
import script from "./Research.vue?vue&type=script&lang=js"
export * from "./Research.vue?vue&type=script&lang=js"

import "./Research.vue?vue&type=style&index=0&id=0889597f&lang=css"
import "./Research.vue?vue&type=style&index=1&id=0889597f&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0889597f"]])

export default __exports__